module.exports = __webpack_public_path__ + "img/cb-lr-r1-n1.335533ca.gif";